import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';

import $ from 'jquery';

@Component({
  selector: 'app-wife',
  templateUrl: './wife.component.html',
  styleUrls: ['./wife.component.scss']
})
export class WifeEligibilityComponent implements OnInit {

  deceased = this.appState.get();
  	all_conditions: boolean = undefined;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	// Form Validation
	formValidate() {

	    // Step#1: Required Inputs and Selects   
	    var inputs = document.querySelectorAll("*[required]");

	    if( inputs.length > 0 ) {
	      for (var i = 0; i < inputs.length; ++i) {
	        var input_elem = <HTMLInputElement>inputs[i];

	        if( input_elem.value == '' ) {
	          inputs[i].parentElement.classList.add("has-error");  
	          input_elem.focus();

	          $('html, body').animate({
	              scrollTop: $( ".has-error" ).offset().top
	          }, 500);

	          return false;
	        
	        } else {
	          inputs[i].parentElement.classList.remove("has-error");  
	        }
	      }
	    }



	    // Step#2: Check Radio Buttons whether they are checked or not
	    var error = false;
	    var radio_buttons_wrap = document.querySelectorAll(".radio-buttons-wrap");

	    for (var i = 0; i < radio_buttons_wrap.length; ++i) {
	      var radio = radio_buttons_wrap[i].querySelectorAll("input[type='radio']");
	      var checked = false;
	      
	      for (var k = 0; k < radio.length; ++k) {
	        var radio_elem = <HTMLInputElement>radio[k];

	        if( radio_elem.checked ) {
	          checked = true;
	          break;
	        }
	      }

	      if( ! checked ) {
	        radio_buttons_wrap[i].parentElement.classList.add("has-error");

	        $('html, body').animate({
	            scrollTop: $( ".has-error" ).offset().top
	        }, 500);

	        return false;

	      } else {
	        radio_buttons_wrap[i].parentElement.classList.remove("has-error");
	      }
	    }


	    return true;
	}


	// Eligibility Check
	eligibilityCheck(deceased: any = false) {
		if( deceased ) {
			this.deceased = deceased;
		}

		if( this.deceased['wife'].level1_wives.length > 0 ) {

	        for (var k = 0; k < this.deceased['wife'].level1_wives.length; ++k) {
	          
	          var this_wife = this.deceased['wife'].level1_wives[k];

	          // If All empty Continue without Checking
	          if( this_wife.muslim == "" && this_wife.deceased_killer == "" && (this_wife.free_person == "true" || this_wife.free_person == "") && this_wife.terminal_illness == "" && this_wife.consummated == "" ) {
	            this.deceased['wife'].level1_wives[k].eligibility = "";
	            continue;
	          
	          // Otherwise Check
	          } else {
	            if( this_wife.muslim == "true" && this_wife.deceased_killer == "true" && this_wife.free_person == "true" && 
	            	(this_wife.terminal_illness == "false" || (this_wife.terminal_illness == "true" && this_wife.consummated == "true")) 
            	) {
	              
	              this.deceased['wife'].level1_wives[k].eligibility = "true";
	              this.all_conditions = true;

	              // If Q1-Q3 is True and Q4 is false = Wife is eligible.
	              // If Q1-  Q5 is True  - Wife is eligible
	            
	            } else {
	              
	              this.deceased['wife'].level1_wives[k].eligibility = "false";
	              
	              if( this.all_conditions != true )  {
	                this.all_conditions = false;
	              }

	            }
	          }

	        }

	        return this.all_conditions;
	    }
	}

	setValues() {

		if( this.deceased['wife'].level1_wives.length > 0 ) {

	        for (var k = 0; k < this.deceased['wife'].level1_wives.length; ++k) {
	          
				var this_wife = this.deceased['wife'].level1_wives[k];

				// If All empty Continue without Checking
				if( this_wife.muslim == "" ) {
					this_wife.muslim = "false";
				}

				if( this_wife.deceased_killer == "" ) {
					this_wife.deceased_killer = "false";

				}
				
				if( this_wife.free_person == "" ) {
					this_wife.free_person = "false";
				}

	        }
	    }
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {
		
		// Form Validation
	    if( this.formValidate() == false ) {
	      return;
	    }

		// Eligibility Test
		this.eligibilityCheck();

		// Save
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

  ngOnInit() {
  }

}
